import { activitySelectors, createAppSelector, pageSelectors, selectCurrentPageId } from "./base";

import type { RootState } from "store";
import { isUnassessablePage } from "utils/page-utils";

export const selectActivityByPageId = createAppSelector(
  [pageSelectors.selectById, activitySelectors.selectEntities],
  (page, activities) => (page?.activity_id && activities[page.activity_id]) || null,
);

export const selectIsUnassessablePage = createAppSelector(
  [pageSelectors.selectById, selectActivityByPageId],
  (page, activity) => isUnassessablePage(page, activity?.category),
);

export const selectCurrentPage = createAppSelector(
  [selectCurrentPageId, pageSelectors.selectEntities],
  (pageId, pages) => (pageId && pageId in pages ? pages[pageId] : null),
);

export const selectCurrentTopicId = createAppSelector(
  [selectCurrentPage, activitySelectors.selectEntities],
  (page, activities) => {
    const activityId = page?.activity_id;
    if (!activityId) return null;
    return activities[activityId]?.topic_id ?? null;
  },
);

export const selectWorksheetIdByPage = (state: RootState, pageId: string | null) =>
  pageSelectors.selectById(state, pageId)?.worksheet_id ?? null;

export const selectPageIdByWorksheetId = createAppSelector(
  [pageSelectors.selectAll, (state, worksheetId: string) => worksheetId],
  (pages, worksheetId) => {
    return pages.find((page) => page.worksheet_id === worksheetId)?.id ?? null;
  },
);

export const selectPageCategoryByPageId = createAppSelector(
  [pageSelectors.selectById],
  (page) => page?.category ?? null,
);

export const selectPageSectionIdByPageId = createAppSelector(
  [pageSelectors.selectById],
  (page) => page?.section_id ?? null,
);
